import React from "react";
import './card.scss'

export class Card extends React.Component<any> {
    render(): React.ReactNode {
        return (
            <div className="card">
            <div className="card__description">
              <span className="card__title">{this.props.cardData.clientName}</span>
              <span className="card__info"> {this.props.cardData.description}</span>
              <div className="card__heading">Technologies used: </div>
              <div className="card__item--list">
                {
                    this.props.cardData.technologies.map((techNeme:any, index:number) => {
                        return (
                            <span className="card__item" key={index}>{techNeme}</span>
                        )
                    })
                }
              </div>
            </div>
          </div>
        )
    }
}

export default Card;